<template>
    <div>
        <p class="lh35 hid" id="konav">&nbsp;</p>
        <div id="content" class="w">
            <!--left nav-->
            <div class="bl_l left">
                <div v-for="(item,index) in cate" :key="index">
                    <router-link :to="{path:'/shop/shopsearch', query:{cate_id:item.id}}" target="_blank" class="l_aa">
                        <img :src="item.piclink" width="45" height="45">
                        <p>{{item.title}}</p>
                    </router-link>
                </div>
                <div class="clear"></div>
                <p class="lh16">&nbsp;</p>
            </div>
            <!-- right content -->
            <div class="bl_m left">
                <!-- right carousel -->
                <div id="bl_m">
                    <catesearch-carousel :height="height" :width="890" :carouselList="banner"></catesearch-carousel>
                </div>
                <!-- right bottom -->
                <router-link :to="{path:'/detail', query:{id:221}}" target="_blank" class="ll_r">
                    <img src="../../assets/image/productBanner/man/product/duyao.jpg" width="290" height="150">
                </router-link>
                <router-link :to="{path:'/detail', query:{id:246}}" target="_blank" class="ll_r">
                    <img src="../../assets/image/productBanner/man/product/pigu.jpg" width="290" height="150">
                </router-link>
                <router-link :to="{path:'/detail', query:{id:21}}" target="_blank" class="ll_r">
                    <img src="../../assets/image/productBanner/man/product/xingkongbei.jpg" width="290" height="150">
                </router-link>
            </div>
            <!--mid over-->
            <div class="clear"></div>
            <div class="over mt35 wbox" id="wbox">
                <div class="c_tt yahei">
                    <h1 class="dinl">男性用品</h1>热卖榜 <em class="c9">MASTERPIECE</em>
                </div>
                <div v-for="(itemss,index) in product" :key="index">
                    <router-link :to="{path:'/detail', query:{id:itemss.id}}" target="_blank" class="dn_a">
                        <img :src="itemss.piclink" width="270" height="270" class="sbm">
                        <div class="h250">
                            <p class="gna pt10">{{itemss.title}}</p>
                            <p class="pt_g">{{itemss.sub_title}}</p>
                            <p class="gp_d mt5">
                                <i class="rmb left">¥</i>
                                <b class="xj left mr5">{{itemss.price}}</b>
                                <em class="cs_o">已售{{itemss.invent_sale}}件</em>
                            </p>
                        </div>
                        <span class="hot_tag"></span>
                    </router-link>
                </div>
            </div>
            <!--one over-->
            <p class="lh30">&nbsp;</p>
            <!-- 热销 -->
            <div class="ov w_hd">
                <router-link :to="{path:'/ranking'}" target="_blank">
                    <img src="../../assets/picture/category/paihangbang.jpg" width="1190" height="90">
                </router-link>
            </div>
        </div>
        <!--content over-->
        <div class="w" id="gdls">
            <div v-for="(item,index) in category" :key="index">
                <div class="blt mt35">
                    <div class="c_tt yahei">
                        <router-link :to="{path:'/shop/shopsearch', query:{cate_id:item.id}}" target="_blank">
                            <h2 class="dinl c3">{{item.title}}</h2>
                        </router-link>
                    </div>
                </div>

                <div class="bdls">
                    <dl class="gl" v-for="(items,indexs) in item.p" :key="indexs" @mouseenter="mouseEnter($event)" @mouseleave="mouseLeave($event)">
                        <dt>
                            <router-link :to="{path:'/detail', query:{id:items.id}}" target="_blank">
                                <img :src="items.piclink" width="270" height="270" class="sbm">
                            </router-link>
                        </dt>
                        <!-- <dd class="simg">
                            <img src="https://s.cccgx.com/t/26x26/images/qu/10201/gallery/20211025025923_30410.jpg" width="26" height="26" class="ss_m">
                        </dd> -->
                        <dd class="simg">
                            <router-link :to="{path:'/detail', query:{id:items.id}}" target="_blank" class="gna">
                                {{items.title}}
                            </router-link>
                        </dd>
                        <dd class="gp_d">
                            {{items.sub_title}}
                        </dd>
                        <dd class="gp_d">
                            <i class="rmb left">¥</i>
                            <b class="xj left">{{items.price}}</b>
                            <em class="cs_o">已售{{items.invent_sale}}件</em>
                        </dd>
                        <dd class="pt5">
                            <em class="i_hot">热销</em>
                            <i class="i_by">包邮</i>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
        <!--gdl content over-->
        <div class="w over">
            <div class="bgw mt35 pd20" style="overflow: hidden;">
                <b class="pr10" style="float:left;">所有男性用品分类：</b>
                <div v-for="items in cate" :key="items.id">
                    <router-link :to="{path:'/shop/shopsearch', query:{cate_id:items.id}}" target="_blank" class="pl10" style="float:left;">
                        <p>{{items.title}}</p>
                    </router-link>
                </div>
            </div>
        </div>
        <!--content over-->
    </div>
</template>

<script>
import Catesearch_carousel from "@/components/common/catesearch-carousel"

export default{
    components:{
        'catesearch-carousel': Catesearch_carousel
    },
    data(){
        return{
            height:'320',
            //数据
            cate:[],
            category:[],
            product:[],
            type: 1,
            banner:[
                {id:420,url:require('@/assets/image/productBanner/man/banner/beidouxing.jpg'),title:"日本全自动飞机杯男用品成人情趣电动加热伸缩口交器男性自慰神器"},
                // {id:221,url:require('@/assets/image/productBanner/man/banner/duyao.jpg'),title:'日本全自动飞机杯男用品成人情趣电动加热伸缩口交器男性自慰神器'},
                {id:252,url:require('@/assets/image/productBanner/man/banner/fuchouzhe.jpg'),title:"日本全自动飞机杯男用品自慰神器进口情趣电动伸缩旋转夹吸口交器"},
                // {id:244,url:require('@/assets/image/productBanner/man/banner/maichong.jpg'),title:"飞机杯男用品阴茎训练器降低龟头敏感度锻炼拉伸按摩私处jj打神器"},
                {id:246,url:require('@/assets/image/productBanner/man/banner/pigu.jpg'),title:"飞机男杯下半身实体真人倒模熟女大硅胶屁股男性专用成人用品玩具"}
            ]
        }
    },
    mounted() {
        this.getManyqjCate();
        this.getManyqjHot();
        this.getManyqjSonHot();
    },
    methods:{
        //获取所有子分类
        getManyqjCate() {
            this.$api.getCategory.getManyqjCate({}).then(res => {
                if (res.code == 200) {
                    this.cate = [];
                    var arr = res.result.soncate;
                    arr.forEach((item,index) => {
                        if (item.show == 1) {
                            this.cate.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            });
        },
        //获取所有热销产品
        getManyqjHot() {
            this.$api.getCategory.getManyqjHot({}).then(res => {
                if (res.code == 200) {
                    this.product = [];
                    var arr = res.result.product;
                    arr.forEach(item => {
                        this.product.push(item);
                    });
                    this.type = res.result.types;
                }
            });
        },
        //获取所有子分类热销产品
        getManyqjSonHot() {
            this.$api.getCategory.getManyqjSonHot({}).then(res => {
                if (res.code == 200) {
                    this.category = [];
                    var arr = res.result.cate;
                    arr.forEach(item => {
                        this.category.push(item);
                    });
                    this.type = res.result.types;
                }
            });
        },
        //   鼠标移入
        mouseEnter($event){
            $event.currentTarget.className="gl hov";
        },
        //   鼠标移除
        mouseLeave($event){
            $event.currentTarget.className="gl";
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/man/Index.vue